module.exports = __webpack_public_path__ + "img/hand-logo.30402f7f.png";